import { render } from "./customerEdit.vue?vue&type=template&id=59d33d6e"
import script from "./customerEdit.vue?vue&type=script&lang=js"
export * from "./customerEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__